<homey-header ngSkipHydration class="sticky z-20 top-0"/>
<p-toast></p-toast>
<p-confirm-dialog/>
<main class="flex-1 flex flex-col items-center text-color relative" [ngClass]="mainBgClass()" xmlns="http://www.w3.org/1999/html">
  <div
    class="w-full max-w-md md:max-w-lg px-pagePadX thin:px-pagePadXSmall py-pagePadY flex flex-col flex-1 relative"
    [ngClass]="innerClass()">
    @if (!initialDataLoaded() && !wasPrerendered) {
      <div class="h-full flex-grow flex items-center justify-center">
        @if (dataUpdateService.loadFailed()) {
          <homey-load-failed/>
        } @else {
          <p-progress-spinner/>
        }
      </div>
    }
    <router-outlet></router-outlet>
  </div>
</main>

<homey-drawer-outlet/>
<homey-debug-button/>
